export abstract class DrawingLibrary {
  /**
* Draws a rounded rectangle using the current state of the canvas.
* If you omit the last three params, it will draw a rectangle
* outline with a 5 pixel border radius
* @param {CanvasRenderingContext2D} ctx
* @param {Number} x The top left x coordinate
* @param {Number} y The top left y coordinate
* @param {Number} width The width of the rectangle
* @param {Number} height The height of the rectangle
* @param {Number} [radius = 5] The corner radius; It can also be an object 
*                 to specify different radii for corners
* @param {Number} [radius.tl = 0] Top left
* @param {Number} [radius.tr = 0] Top right
* @param {Number} [radius.br = 0] Bottom right
* @param {Number} [radius.bl = 0] Bottom left
* @param {Boolean} [fill = false] Whether to fill the rectangle.
* @param {Boolean} [stroke = true] Whether to stroke the rectangle.
*/

  public static roundRect(ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: number, fill: boolean, stroke: boolean) {

    ctx.strokeStyle = "#fff";
    
    const drawRadius = { tl: radius, tr: radius, br: radius, bl: radius };

    ctx.beginPath();
    ctx.moveTo(x + drawRadius.tl, y);
    ctx.lineTo(x + width - drawRadius.tr, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + drawRadius.tr);
    ctx.lineTo(x + width, y + height - drawRadius.br);
    ctx.quadraticCurveTo(x + width, y + height, x + width - drawRadius.br, y + height);
    ctx.lineTo(x + drawRadius.bl, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - drawRadius.bl);
    ctx.lineTo(x, y + drawRadius.tl);
    ctx.quadraticCurveTo(x, y, x + drawRadius.tl, y);
    ctx.closePath();

    if (fill) {
      ctx.fill();
    }
    if (stroke) {
      ctx.stroke();
    }
  }
}
